/**
 * Constantes de animación reutilizables
 * Manteniendo las curvas de easing y duraciones del diseño original
 */

export const EASING = {
  smooth: [0.22, 1, 0.36, 1], // Cubic bezier para animaciones suaves
};

export const ANIMATION_VARIANTS = {
  fadeUp: {
    hidden: { opacity: 0, y: 44 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.75,
        delay,
        ease: EASING.smooth,
      },
    }),
  },

  fadeLeft: {
    hidden: { opacity: 0, x: -60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { 
        duration: 0.85, 
        ease: EASING.smooth 
      },
    },
  },

  fadeRight: {
    hidden: { opacity: 0, x: 60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.85,
        delay: 0.15,
        ease: EASING.smooth,
      },
    },
  },

  staggerContainer: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { 
        staggerChildren: 0.14, 
        delayChildren: 0.1 
      },
    },
  },

  cardVariant: {
    hidden: { 
      opacity: 0, 
      y: 40, 
      filter: "blur(6px)" 
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { 
        duration: 0.65, 
        ease: EASING.smooth 
      },
    },
  },

  scaleIn: {
    hidden: { scale: 0.95, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: EASING.smooth,
      },
    },
  },
};

export const TICKER_CONFIG = {
  duration: 32, // segundos para completar un ciclo
  items: [
    "¿Cuántos puntos de red necesita su nueva instalación?",
    "¿Su planta tiene el sistema de climatización adecuado?",
    "¿Qué normas de seguridad SST debe cumplir su empresa?",
    "¿Cuántos colaboradores utilizarán el espacio?",
    "¿Cuenta con planos o croquis del área a intervenir?",
    "¿Requiere mantenimiento preventivo o correctivo?",
    "¿Cuál es el plazo de ejecución que necesita?",
    "¿Necesita equipamiento EPP certificado para su personal?",
  ],
};
